




















































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import CabeceraModalCrear from '@/reusable/Modal/CabeceraModal.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';

import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import opcionesCS from '@/pantallas/Conecta/CambiosServicio/opcionesCS.vue';
import CabezeraCS from '@/pantallas/Conecta/CambiosServicio/CabezeraCS.vue';
import EquipoCliente from '@/pantallas/Conecta/CambiosServicio/EquipoCliente.vue';
import retiroEquipo from '@/pantallas/Conecta/CambiosServicio/retiroEquipo.vue';
import reemplazaEquipo from '@/pantallas/Conecta/CambiosServicio/reemplazaEquipo.vue';
import CambioSIM from '@/pantallas/Conecta/CambiosServicio/CambioSIM.vue';
import NuevoCambioSIM from '@/pantallas/Conecta/CambiosServicio/NuevoCambioSIM.vue';
import { fetchCambioServicio } from './fetchCambioServicio';
import CambioActivoCliente from '@/pantallas/Conecta/CambiosServicio/CambioActivoCliente.vue';
import NuevoCambioActivoCliente from '@/pantallas/Conecta/CambiosServicio/NuevoCambioActivoCliente.vue';

@Component({
  components: {
    CabeceraModalCrear,
    ModalMantenedor,
    FormFieldsContainer,
    DatePicker,
    opcionesCS,
    CabezeraCS,
    EquipoCliente,
    retiroEquipo,
    reemplazaEquipo,
    CambioSIM,
    CambioActivoCliente,
    NuevoCambioActivoCliente,
    NuevoCambioSIM,
  },
})
export default class modalverdetalleCS extends Vue {
  @Prop({ default: true }) show: boolean;
  @Prop({ default: false }) dialog: boolean;
  @Prop({ default: null }) id_cs: any;
  @Prop({ default: null }) accion_modal: any;
  @Prop({ default: null }) estado: any;
  nuevo_activo: boolean = false;
  nueva_sim: boolean = false;
  readonly $snotify: Snotify;
  accion_de_cambio: any;
  envio_tecnico: any;
  envio_Equipo: any;
  envio_numero: any;
  serienumero: any;
  tipoeqid: any;
  tecnico_id: any;
  titulo: any;
  titulo_reemplazo: any;
  titulo_cambio_activo: any;
  titulo_nuevo_activo: any;
  serienumero_entrante: any;
  titulo_cambio_sim_old: any;
  titulo_cambio_sim_new: any;
  tipoeqid_entrante: any;
  cliente_id_saliente: any;
  flota_saliente: any;
  patente_saliente: any;
  cliente_id_entrante: any;
  flota_entrante: any;
  patente_entrante: any;
  simserienumero_od: any;
  simserienumero_new: any;
  // Inicializar accion en data()
  data(): {
    accion_de_cambio: any;
    envio_tecnico: any;
    envio_Equipo: any;
    envio_numero: any;
    serienumero: any;
    tipoeqid: any;
    tecnico_id: any;
    titulo: any;
    titulo_reemplazo: any;
    serienumero_entrante: any;
    tipoeqid_entrante: any;
    cliente_id_saliente: any;
    flota_saliente: any;
    patente_saliente: any;
    cliente_id_entrante: any;
    flota_entrante: any;
    patente_entrante: any;
    titulo_cambio_activo: any;
    titulo_nuevo_activo: any;
    titulo_cambio_sim_old: any;
    simserienumero_od: any;
    titulo_cambio_sim_new: any;
  } {
    return {
      accion_de_cambio: null,
      envio_tecnico: null,
      envio_Equipo: '(No has seleccionado aún un equipo para esta Operación)',
      envio_numero: null,
      serienumero: null,
      tipoeqid: null,
      tecnico_id: null,
      titulo: 'Equipo Instalado',
      titulo_reemplazo: 'Reemplazo Equipo',
      titulo_cambio_activo: 'Reemplazo SIM',
      titulo_nuevo_activo: 'Nuevo Activo',
      titulo_cambio_sim_old: 'Cambio de Sim',
      serienumero_entrante: null,
      tipoeqid_entrante: null,
      cliente_id_saliente: null,
      flota_saliente: null,
      patente_saliente: null,
      cliente_id_entrante: null,
      flota_entrante: null,
      patente_entrante: null,
      simserienumero_od: null,
      titulo_cambio_sim_new: null, // o cualquier valor inicial que desees
      // ...otros datos
    };
  }
  cabeceraCS: any;
  EquipoClienteCS: any;

  reemplazaEquipoCS: any;
  CambioActivoClienteCS: any;
  CambioSIMCS: any;

  async probar() {
    // Aquí puedes manejar el valor emitido desde todos los componentes
    // Información de la cabecera
    this.loadingService.showLoading();
    var PAYLOAD: any = {};
    PAYLOAD.MODULO = '172';
    PAYLOAD.USUARIO = this.getUserID();
    PAYLOAD.CURENT_CLIENTE_ID = this.getCliente();
    PAYLOAD.ACCION = this.accion_modal;
    PAYLOAD.ACCION_DE_CAMBIO = this.accion_de_cambio;
    this.cabeceraCS = this.$refs.CabezeraCSRef;
    PAYLOAD.CABECERA = this.cabeceraCS.formFields;
    this.EquipoClienteCS = this.$refs.EquipoClienteCSRef;
    PAYLOAD.EQUIPO_CLIENTE = this.EquipoClienteCS.formFields;

    if (this.accion_de_cambio == 'reemplazaEquipo') {
      this.loadingService.showLoading();
      this.reemplazaEquipoCS = this.$refs.reemplazaEquipoCSRef;
      PAYLOAD.REEMPLAZA_EQUIPO = this.reemplazaEquipoCS.formFields;
      return fetchCambioServicio(PAYLOAD, 'conectaCambioServicio/crear_cambio')
        .then((data: any) => {
          if (data.data.CODIGO_RESPUESTA == '1') {
            this.$snotify.success(
              'El Reemplazo de Equipo ha sido realizado exitosamente',
              {
                timeout: 3000,
              }
            );
            this.loadingService.hideLoading();
            this.closeModal();
          } else {
            this.loadingService.hideLoading();
            this.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          }
        })
        .catch((error: any) => {
          this.loadingService.hideLoading();
          return null;
        })
        .finally(() => {
          return null;
        });
    } else if (this.accion_de_cambio == 'CambioSIM') {
      this.loadingService.showLoading();
      this.CambioSIMCS = this.$refs.CambioSIMCSRef;
      PAYLOAD.CAMBIO_SIM = this.CambioSIMCS.formFields;
      return fetchCambioServicio(
        PAYLOAD,
        'conectaCambioServicio/crear_cambio_sim'
      )
        .then((data: any) => {
          if (data.data.CODIGO_RESPUESTA == '1') {
            this.$snotify.success(
              'El Cambio de SimCard ha sido realizado exitosamente',
              {
                timeout: 3000,
              }
            );
            this.loadingService.hideLoading();
            this.closeModal();
          } else {
            this.loadingService.hideLoading();
            this.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          }
        })
        .catch((error: any) => {
          this.loadingService.hideLoading();
          return null;
        })
        .finally(() => {
          return null;
        });
    } else if (this.accion_de_cambio == 'CambioActivoCliente') {
      const caracteresEspeciales = /[!@#$%^&*()+\=\[\]{};':"\\|,.<>\/?\s]+/;
      this.CambioActivoClienteCS = this.$refs.CambioActivoClienteCSRef;
      let respuesta = await this.CambioActivoClienteCS.$validator.validateAll();

      PAYLOAD.CAMBIO_ACTIVO_CLIENTE = this.CambioActivoClienteCS.formFields;
      let prueba = PAYLOAD.CAMBIO_ACTIVO_CLIENTE.patente_vehiculo_new.value;
      if (prueba === '' || caracteresEspeciales.test(prueba)) {
        this.$snotify.error(
          'Por favor ingrese el campo Patente en un formato sin cáracteres especiales ni tampoco vacio.',
          {
            timeout: 3000,
          }
        );
        this.loadingService.hideLoading();
        return;
      }
      return fetchCambioServicio(
        PAYLOAD,
        'conectaCambioServicio/crear_cambio_activo'
      )
        .then((data: any) => {
          if (data.data.CODIGO_RESPUESTA == '1') {
            this.$snotify.success(
              'El Cambio de Activo ha sido realizado exitosamente',
              {
                timeout: 3000,
              }
            );
            this.loadingService.hideLoading();
            this.closeModal();
          } else {
            this.loadingService.hideLoading();
            this.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          }
        })
        .catch((error: any) => {
          this.loadingService.hideLoading();
          return null;
        })
        .finally(() => {
          return null;
        });
    } else if (this.accion_de_cambio == 'RetiroEquipo') {
      this.loadingService.showLoading();
      return fetchCambioServicio(PAYLOAD, 'conectaCambioServicio/crear_retiro')
        .then((data: any) => {
          if (data.data.CODIGO_RESPUESTA == '1') {
            this.loadingService.hideLoading();
            this.$snotify.success('El Retiro ha sido efectuado exitosamente', {
              timeout: 3000,
            });
            this.closeModal();
          } else {
            this.loadingService.hideLoading();
            this.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          }
        })
        .catch((error: any) => {
          this.loadingService.hideLoading();
          return null;
        })
        .finally(() => {
          return null;
        });
    } else {
      this.loadingService.hideLoading();
      this.$snotify.error('Debe seleccionar una Opción', { timeout: 3000 });
    }
  } // end funcion probar
  equipo_saliente: any;
  numero_de_servicio: any;

  handleInputFromOpcionesCS(value: string) {
    // Aquí puedes manejar el valor emitido desde el componente opcionesCS
    this.accion_de_cambio = value;
    this.numero_de_servicio = this.cabeceraCS.formFields.numero_cambio_servicio.value;
    this.equipo_saliente = this.EquipoClienteCS.formFields.serie_activa_numero.vale;
  }
  pasoActivoIndex = 1;
  pasos = {
    informacionGeneral: {
      accion: 'Crear - Información General',
      visible: true,
      step: 1,
    },
  };

  showInfo: boolean = true;
  readonly loadingService = new LoadingService();

  handleInfoGeneral() {
    this.showInfo = true;
  }
  async mounted() {}

  getUserID(): any {
    let user = localStorage.getItem('user');
    let id = JSON.parse(user.replace(/'/g, '"')).id;
    return id;
  }

  closeModal() {
    this.$emit('modalOrdenCompraEmit', false);
  }

  getCliente() {
    /*  TODO VERIFICAR */
    let user = localStorage.getItem('user');
    let clienteDefecto = JSON.parse(
      localStorage.getItem('user').replace(/'/g, '"')
    ).clienteDefecto;
    return clienteDefecto;
  }

  closeReporte() {
    this.closeModal();
  }

  recibirTecnico(event: any) {
    this.envio_tecnico = event;
  }
  envio_Equipo_texto: any;
  recibirRecibirEquipo(event: any) {
    this.envio_Equipo_texto = event;
    this.envio_Equipo =
      'Vas a dar de baja el equipo No. ' + this.envio_Equipo_texto + ' .';
  }
  recibirRecibirNumero(event: any) {
    this.envio_numero = event;
  }
  activar_modo(event: any) {
    this.serienumero = event.serienumero;
    this.tipoeqid = event.tipoeqid;
    this.tecnico_id = event.tecnico_id;
    if (event.accion_de_cambio == 'cambiosernuevo_equipo') {
      this.accion_de_cambio = 'reemplazaEquipo';
      this.titulo = 'Equipo Saliente';
      this.titulo_reemplazo = 'Equipo Entrante';
      this.serienumero_entrante = event.serienumero_entrante;
      this.tipoeqid_entrante = event.tipoeq_entrante;
    } else if (event.accion_de_cambio == 'cambiosernuevo_activo_cliente') {
      this.accion_de_cambio = 'CambioActivoCliente';
      this.cliente_id_saliente = event.cliente_id_saliente;
      this.flota_saliente = event.flota_saliente;
      this.patente_saliente = event.patente_saliente;
      this.cliente_id_entrante = event.cliente_id_entrante;
      this.flota_entrante = event.flota_entrante;
      this.patente_entrante = event.patente_entrante;
      this.titulo_cambio_activo = 'Activo Saliente';
      this.nuevo_activo = true;
      this.titulo = 'Equipo Afectado';
    } else if (event.accion_de_cambio == 'cambioserretira_equipo') {
      this.accion_de_cambio = 'RetiroEquipo';
      this.titulo = 'Equipo Saliente';
    } else if (event.accion_de_cambio == 'cambiosernuevo_sim') {
      this.accion_de_cambio = 'CambioSIM';
      this.titulo_cambio_sim_old = 'Sim Reemplazada';
      this.titulo_cambio_sim_new = 'Sim Nueva';
      this.simserienumero_new = event.cambiosimserienumero;
      this.simserienumero_od = event.simserienumero;
      this.titulo = 'Equipo Afectado';
      this.nueva_sim = true;
    } else {
      console.log('No fue posible indentificar accion');
    }
  }
  @Watch('accion_de_cambio')
  onAccionDeCambioChanged(newVal: any, oldVal: any) {
    // Verifica si el valor de 'accion_de_cambio' ha cambiado
    if (newVal !== oldVal) {
      // Actualiza el valor de 'titulo' en el componente 'EquipoCliente'
      const equipoClienteComponent: any = this.$refs.EquipoClienteCSRef;
      equipoClienteComponent.titulo = newVal;
    }
  }
} //end class
